function pad(n) {
  return String(n).padStart(2, '0');
}

function toICSDate(dateStr) {
  const d = new Date(dateStr);
  return [
    d.getUTCFullYear(),
    pad(d.getUTCMonth() + 1),
    pad(d.getUTCDate()),
    'T',
    pad(d.getUTCHours()),
    pad(d.getUTCMinutes()),
    '00Z',
  ].join('');
}

export function generateICS(activity) {
  const start = activity.start_time ? toICSDate(activity.start_time) : null;
  const durationMs = (activity.duration_minutes || 60) * 60 * 1000;
  const end = activity.start_time
    ? toICSDate(new Date(new Date(activity.start_time).getTime() + durationMs).toISOString())
    : null;

  const title = activity.title || activity.activity_type || 'Activity';
  const description = activity.description || '';
  const location = activity.location_name || '';
  const uid = `${activity.id}@covo`;

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Covo//Covo Calendar//EN',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `SUMMARY:${title}`,
    description ? `DESCRIPTION:${description.replace(/\n/g, '\\n')}` : null,
    location ? `LOCATION:${location}` : null,
    start ? `DTSTART:${start}` : null,
    end ? `DTEND:${end}` : null,
    'END:VEVENT',
    'END:VCALENDAR',
  ].filter(Boolean).join('\r\n');

  const blob = new Blob([lines], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${title.replace(/\s+/g, '-').toLowerCase()}.ics`;
  a.click();
  URL.revokeObjectURL(url);
}

export function getGoogleCalendarUrl(activity) {
  const title = encodeURIComponent(activity.title || activity.activity_type || 'Activity');
  const details = encodeURIComponent(activity.description || '');
  const location = encodeURIComponent(activity.location_name || '');

  const fmt = (dateStr) => {
    if (!dateStr) return '';
    return new Date(dateStr).toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const start = fmt(activity.start_time);
  const durationMs = (activity.duration_minutes || 60) * 60 * 1000;
  const end = activity.start_time
    ? fmt(new Date(new Date(activity.start_time).getTime() + durationMs).toISOString())
    : '';

  const dates = start && end ? `${start}/${end}` : '';

  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&details=${details}&location=${location}&dates=${dates}`;
}
